import * as yup from "yup";

export const signupSchema = yup.object({
  acceptedTerms: yup
    .boolean()
    .oneOf([true], "Please accept the Naranel Terms & Conditions.")
    .required("Please accept the Naranel Terms & Conditions."),
  fullname: yup.string().required("Full name is required."),
  countryId: yup.string().required("Country is required."),
  categoryIds: yup.array().min(1, "You need to select at lease one expertise."),
  bio: yup.string().required("About me description is required."),
  mobile: yup.string().required("Mobile number is required."),
  email: yup
    .string()
    .required("Email is required.")
    .email("Invalid email format."),
  gender: yup.string().required("Gender is required."),
  address: yup.string().required("Address is required."),
});

export const verifySignupSchema = yup.object({
  token: yup
    .string()
    .required("Verification code is required.")
    .length(4, "Invalid verification code format."),
});

export const loginSchema = yup.object({
  email: yup
    .string()
    .required("Email is required.")
    .email("Invalid email format."),
  password: yup.string().required("Password is required."),
});

export const forgotPasswordSchema = yup.object({
  email: yup
    .string()
    .required("Email is required.")
    .email("Invalid email format."),
});

export const resetPasswordSchema = yup.object({
  code: yup
    .string()
    .required("Confirmation code is required.")
    .length(4, "Confirmation code should be 4 digits."),
  password: yup.string().required("Password is required."),
  password_confirm: yup.string().required("Password confirmation is required."),
});

export const updateSettingSchema = yup.object({
  fullname: yup.string().required("Full name is required."),
  countryId: yup.string().required("Country is required."),
  expertises: yup.array().min(1, "You need to select at least one expertise."),
  bio: yup.string().required("About me description is required."),
  mobile: yup.string().required("Mobile number is required."),
  email: yup
    .string()
    .required("Email is required.")
    .email("Invalid email format."),
  gender: yup.string().required("Gender is required."),
  address: yup.string().required("Address is required."),
});

export const createCourseSchema = yup.object({
  name: yup.string().required("Title is required."),
  level: yup.string().required("Level is required."),
  description: yup.string().required("Description is required."),
  prices: yup
    .array()
    .of(
      yup.object().shape({
        currency: yup.string().required("Currency is required"),
        price: yup
          .number()
          .typeError("Price must be a number")
          .positive("Price must be greater than 0")
          .required("Price is required"),
      }),
    )
    .min(1, "You must add at least one price with a currency"),
  categoryId: yup.string().required("Category is required."),
  languegeId: yup.string().required("Languege is required."),
  tagIds: yup.array().min(1, "You need to select at least one tag."),
});

export const createCourseWithPromotionSchema = yup.object({
  name: yup.string().required("Title is required."),
  level: yup.string().required("Level is required."),
  description: yup.string().required("Description is required."),
  prices: yup
    .array()
    .of(
      yup.object().shape({
        currency: yup.string().required("Currency is required"),
        price: yup
          .number()
          .typeError("Price must be a number")
          .positive("Price must be greater than 0")
          .required("Price is required"),
      }),
    )
    .min(1, "You must add at least one price with a currency"),
  categoryId: yup.string().required("Category is required."),
  languegeId: yup.string().required("Languege is required."),
  promotion: yup.object().shape({
    amount: yup
      .number()
      .transform((val, orig) => (orig === "" ? null : val))
      .typeError("Enter a valid number")
      .min(0, "Must be ≥ 0")
      .max(100, "Must be ≤ 100")
      .required("Amount is required"),
  }),
  tagIds: yup.array().min(1, "You need to select at least one tag."),
});

export const createProductSchema = yup.object({
  title: yup.string().required("Title is required."),
  description: yup.string().required("Description is required."),
  link: yup.string().required("Link is required."),
  lessonIds: yup.array().min(1, "You need to select at least one lesson."),
});

export const createSectionSchema = yup.object({
  title: yup.string().required("Title is required."),
});

export const createLessonSchema = yup.object({
  title: yup.string().required("Title is required."),
  // video: yup.mixed().required("Video is required."),
});

export const createQuizSchema = yup.object({
  questions: yup.array().of(
    yup.object().shape({
      title: yup.string().trim().required("Question title is required"),
      answers: yup
        .array()
        .of(
          yup.object().shape({
            title: yup.string().trim().required("Answer title is required"),
            isAnswer: yup.boolean(),
          }),
        )
        .min(1, "At least one answer is required")
        .test(
          "at-least-one-checked",
          "Select at least one correct answer",
          (answers) => answers?.some((a) => a.isAnswer === true),
        ),
    }),
  ),
  quiz_title: yup.string().required("Quiz title is required."),
});

export const createCouponSchema = yup.object({
  code: yup.string().required("Code is required."),
  amount: yup
    .number()
    .typeError("Discount amount must be a number")
    .positive("Discount amount must be greater than 0")
    .required("Discount amount is required"),
  usageLimit: yup
    .number()
    .typeError("Usage limit must be a number")
    .positive("Usage limit must be greater than 0"),
});

export const updateCouponSchema = yup.object({
  usageLimit: yup
    .number()
    .typeError("Usage limit must be a number")
    .positive("Usage limit must be greater than 0"),
});

export const replyReviewSchema = yup.object({
  comment: yup.string().required("Comment is required."),
});

export const reportReviewSchema = yup.object({
  reason: yup.string().required("Reason is required."),
});

export const updatePasswordSchema = yup.object({
  currentPassword: yup.string().required("Current password is required."),
  newPassword: yup.string().required("New password is required."),
  newPasswordConfirm: yup
    .string()
    .required("New password confirmation is required."),
});

export const generateCertificateSchema = yup.object({
  certificate: yup.object().required("Certificate is required."),
});

export const createPostSchema = yup.object({
  text: yup.string().required("Content is required"),
});

export const addSocialMediaSchema = yup.object({
  type: yup.string().required("Platform is required"),
  link: yup
    .string()
    .trim()
    .url("Enter a valid URL")
    .required("Account link is required"),
});
